(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  Header,
  CharityContainer,
  Links,
  Params
} = svs.lyckoplatsen.components.page_start.react.components;
const StartPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);
  return React.createElement("div", {
    className: "lp-page-start ".concat(isLoaded ? 'page-loaded' : '')
  }, React.createElement(Header, null), React.createElement(WidgetArea, {
    areaName: "startPageTopWidgetArea",
    widgetArea: "startPageTopWidgetArea"
  }), React.createElement(CharityContainer, null), React.createElement(WidgetArea, {
    className: "start-bottom-widget-area",
    areaName: "startPageBottomWidgetArea",
    widgetArea: "startPageBottomWidgetArea"
  }), React.createElement(Links, null), React.createElement(Params, null));
};
setGlobal('svs.lyckoplatsen.components.page_start.react', {
  StartPage
});

 })(window);